import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RequireAuth } from '@techsofit/app-kit';
import { BrandSplash } from '@techsofit/ui';
import { AdminShell } from './components/AdminShell';
import { LoginPage } from './pages/Login';
import { HomePage } from './pages/Home';
import { SubscriptionPlansPage } from './pages/SubscriptionPlans';
import { ProgramsPage } from './pages/Programs';
import { ProgramWorkoutsPage } from './pages/ProgramWorkouts';
import { ExercisesPage } from './pages/Exercises';
import { BadgesPage } from './pages/Badges';
import { LearnPage } from './pages/Learn';
import { NutritionPage } from './pages/Nutrition';
import { BillingPage } from './pages/Billing';
import { RevenuePage } from './pages/Revenue';
import { GymDetailPage } from './pages/GymDetail';
import { SettingsPage } from './pages/Settings';
import { LeadsPage } from './pages/Leads';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <RequireAuth fallback={<BrandSplash />}>
        <AdminShell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <HomePage /> },
      { path: 'plans', element: <SubscriptionPlansPage /> },
      { path: 'programs', element: <ProgramsPage /> },
      { path: 'programs/:id/workouts', element: <ProgramWorkoutsPage /> },
      { path: 'exercises', element: <ExercisesPage /> },
      { path: 'badges', element: <BadgesPage /> },
      { path: 'learn', element: <LearnPage /> },
      { path: 'nutrition', element: <NutritionPage /> },
      { path: 'billing', element: <BillingPage /> },
      { path: 'revenue', element: <RevenuePage /> },
      { path: 'leads', element: <LeadsPage /> },
      { path: 'gyms/:id', element: <GymDetailPage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: 'messages', element: <Navigate to="/settings" replace /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
